import styled, { css } from "styled-components";
import { font } from "../../constants/font";
import { STATIC_PATH } from "../../constants/config";

// Add InputStyles
const InputStyles = css`
  font-size: 16px !important;
  @media screen and (max-width: 767px) {
    font-size: 16px !important;
  }
`;

export const DropdownWrap = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 33px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Footer = styled.div`
  padding: 0px 30px 30px;
`;

export const DropdownWraps = styled.div`
  width: ${(props) => props.width || "665px"};
  @media screen and (max-width: 767px) {
    width: auto;
  }
  cursor: ${(props) => (props.isDisable ? "not-allowed" : "pointer")};
  z-index: 1;
`;

export const DropdownHeaders = styled.div`
  display: ${(props) => (props.isDisable ? "none" : "flex")};
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #dce0e3;

  height: 44px;
  padding: 0px 20px;
  cursor: ${(props) => (props.isDisable ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.isDisable ? "none" : "auto")};
  border-radius: ${(props) =>
    props.isCardUpdate ? "12px 12px 0px 0px" : "12px"};

  &:last-child {
    border-radius: 12px;
  }
  background: #ffffff;
  @media screen and (max-width: 767px) {
    img {
      display: none;
    }
  }
`;

export const UpgradCard = styled.div`
  background: "#ffffff";
  box-shadow: ${(props) => (props.active ? "0px 1px 8px #00baff3d" : "")};
  border: ${(props) =>
    props.active ? "2px solid #00BAFF" : "1px solid #DCE0E3"};
  border-radius: 16px;
  width: ${(props) => props.width || "320px"};
  height: ${(props) => props.height || "auto"};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: ${(props) => props.padding || "24px"};
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
  cursor: ${props => props.isDisabled ? "not-allowed" : "pointer"};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const PricingModalFooter = styled.div`
  background: #efebff 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 16px 0px;
  opacity: 1;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    gap: 0px;
  }
`;

export const DropdownHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 24px;
`;

export const Line = styled.div`
  width: 455px;
  height: 1px;
  background-color: #dce0e3;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SubTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const DropdownContent = styled.div`
  ${InputStyles}
  overflow: hidden;

  transition: max-height 0.3s ease-out;
  padding: 13px 20px;
  background: #ffffff;
  border: 1px solid #dce0e3;
  border-top: 0px;
  border-radius: 0px 0px 8px 8px;
  display: ${(props) => (props.isVisible ? "block" : "none")};
  input,
  textarea,
  select {
    font-size: 16px !important;
  }

  & iframe input::-webkit-input-placeholder {
    font-size: 15px !important;
  }

  & #card-number-editor iframe input {
    font-size: 17px !important;
  }

  & #zipcode-editor iframe input {
    padding-left: 17px;
  }
`;

export const FeatureList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: 16px;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 15px;
  color: #313345;
  line-height: 1.5;

  &::before {
    content: "";
    display: inline-block;
    width: 18px;
    height: 18px;
    background-image: url(${STATIC_PATH}green-tick.svg);
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 2px;
    flex-shrink: 0;
  }
`;

export const HeadingWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0px 15px;
  &.paymentSuccess {
    justify-content: center;
    align-items: center;
    align-items: center;
    height: 100%;
    margin: auto;
    width: 100%;
  }
  .assets-content {
    padding: 15px 50px 0px 0px;
    width: 100%;
    @media screen and (min-width: 768px) and (max-width: 992px) {
      padding: 15px 0px 0px;
    }
    @media (max-width: 767px) {
      width: 100%;
      padding: 15px 0px 0px;
    }
  }
`;

export const LabelWrap = styled.div`
  ${InputStyles}
  display: flex;
  justify-content: ${(props) =>
    props.isCardUpdate ? "space-between" : "flex-start"};
  gap: 16px;
  padding-top: 13px;
  input {
    font-size: 16px !important;
  }
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    flex-direction: column;
    label + div {
      width: 100%;
    }
  }
`;

export const IndividualLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Labels = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  pointer-events: none;
  @media screen and (min-width: 768px) and (max-width: 992px) {
    height: auto;
  }

  @media screen and (max-width: 767px) {
    height: auto;
  }
`;

export const CardOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const ImageWrap = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const PlanCardHead = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 10px;
`;

export const EnterpriseHead = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 10px;
`;

export const ImageContainer = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

export const CheckboxWrapper = styled.div`
  position: relative;
  margin-right: 9px;
  pointer-events: none;
  cursor: pointer;
`;

export const Checkbox = styled.input`
  opacity: 0;
  position: absolute;
  pointer-events: none;
  cursor: pointer;
`;

export const Divide = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const CheckMark = styled.div`
  width: 18px;
  height: 18px;
  background-color: ${(props) => (props.checked ? "#84bf10" : "transparent")};
  border-radius: 50%;
  border: ${(props) =>
    props.checked ? `1px solid transparent` : "1px solid #BDBEC6"};
  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    content: "";
    display: block;
    width: 4px;
    height: 10px;
    border-style: solid;
    border-color: #ffffff;
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
    position: relative;
    top: -1px;
  }
`;

export const SummaryHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .drop-down {
    border: unset;
    position: relative;
    padding-left: 12px;
    &::before {
      content: url(${STATIC_PATH}world.svg);
      position: absolute;
      left: -14px;
      top: -8px;
      z-index: 1;
    }
  }
`;

export const OrderSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

export const DropDownContainer = styled.div`
  padding-right: 10px;
`;

export const Body = styled.div`
  padding: 40px;
  background: ${(props) => props.background || "#ffffff"};
  height: calc(100vh - 212px);
  overflow: auto;
  border-radius: 0px 16px 16px 0px;
  @media screen and (min-width: 768px) and (max-width: 992px) {
    height: auto;
  }

  .selected-option {
    background: #f8f8f8;
  }

  .drop-down {
    border: unset;
    position: relative;
    padding-left: 12px;
    background: #f8f8f8;
    &::before {
      content: url(${STATIC_PATH}world.svg);
      position: absolute;
      left: 6px;
      top: 12px;
      z-index: 1;
    }
  }

  .subscription-message {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    overflow: visible;
    @media screen and (min-width: 1024px) {
      &::after {
        content: "";
        position: absolute;
        background: #dce0e3;
        width: 40px;
        top: 50%;
        right: -52px;
        height: 1px;
        transform: translateY(-50%);
      }
      &::before {
        content: "";
        position: absolute;
        background: #dce0e3;
        width: 40px;
        top: 50%;
        left: -52px;
        height: 1px;
        transform: translateY(-50%);
      }
    }
  }

  @media screen and (max-width: 767px) {
    height: auto;
    overflow: auto;
  }
`;

export const BodyPricingContainer = styled.div`
  padding: 40px 40px 0px 40px;
  background: "#ffffff";
  overflow: auto;
  border-radius: 0px 16px 16px 0px;
  @media screen and (max-width: 767px) {
    padding: 32px 20px;
  }
  .pricingModalTitle {
    @media screen and (max-width: 767px) {
      text-align: center;
      font-size: ${font.normal_600_16};
      padding: 32px 20px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 992px) {
    height: auto;
  }
`;

export const TopWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px;
  border-radius: 12px;
  padding: 22px 0px 0px;
  flex-wrap: wrap;
`;

export const CouponWrapper = styled.div`
  ${InputStyles}
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 12px;
  background: #f3f3f3;
  height: 57px;
  input {
    font-size: 16px !important;
  }
`;

export const SectionWrap = styled.div`
  display: flex;
  align-items: center;
  margin: ${(props) => props.margin || "unset"};
  height: ${(props) => (props.height ? "50px" : "auto")};
  justify-content: ${(props) => props.justifyContent || "flex-start"};
  gap: ${(props) => props.gap || "0px"};
  padding: 20px 30px;
  background: #ffffff;
  border-radius: 12px;
  border: ${(props) => (props.border ? "1px solid #DCE0E3" : "unset")};
  box-shadow: ${(props) =>
    props.boxShadow ? "0px 3px 10px rgba(0, 0, 0, 0.16)" : "unset"};
`;

export const List = styled.ul`
  list-style: none;
  padding: 0px;
  margin: 0px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0px;
    border-bottom: 1px solid #dce0e3;
    &:last-child {
      border-bottom: unset;
    }
  }
`;

export const CouponInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: 1px solid #dce0e3;
  height: 100%;
  padding-left: 10px;
  border-radius: 12px;
`;

export const PaymentFooter = styled.div`
  display: flex;
  justify-content: center;
  // padding-top: 40px;
  flex-wrap: wrap;
  position: relative;
  .pay img {
    left: 188px !important;
  }
`;

export const Flex = styled.div`
  display: flex;
  @media screen and (min-width: 767px) and (max-width: 992px) {
    flex-direction: column;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;
export const FlexSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (min-width: 768px) and (max-width: 992px) {
    padding: 30px 0px;
  }
  @media screen and (max-width: 767px) {
    padding: 30px 0px;
  }
`;

export const ImageFlexSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  @media screen and (max-width: 767px) {
    height: 100%;
  }
`;

export const PricingPageFlexImage = styled.img`
  max-width: 100%;
  height: auto;
  @media screen and (max-width: 767px) {
    border-radius: 16px;
  }
`;

export const TwoCol = styled.div``;

export const Column = styled.div`
  width: 745px;
  @media screen and (min-width: 768px) and (max-width: 992px) {
    width: 100% !important;
  }
  @media screen and (max-width: 767px) {
    width: 100% !important;
  }
  &.flex-col {
  background: transparent linear-gradient(162deg, #4BD5FF 0%, #00A7FF 100%);
    @media only screen and (max-width: 992px) {
      display: none;
    }
  }
`;

export const Details = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  select {
    margin-left: auto;
    color: #ff7819;
    border: none;
    font: ${font.normal_16_22};
  }

  .drop-down {
    text-transform: capitalize;
    .selected-option {
      padding: 0px;
    }
  }

  .prorate {
    margin-left: -6px;
  }
`;

export const PlanAndTeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 34px 0px 20px 0px;
  border-bottom: 1px solid rgb(220, 224, 227);
`;

export const PlanDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PlanBadge = styled.div`
  border-radius: 50px;
  margin: 0px 8px;
  padding: 0px 8px;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Regularprice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AmountContainer = styled.div`
  display: flex;
  gap: 2px;
  align-items: end;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  justify-content: center;
  width: 100%;
  .amount {
    position: relative;
    padding: 0px 36px 0px 17px;
    &:before {
      content: "${(props) => props.symbol || "$"}";
      position: absolute;
      top: 5px;
      left: 0px;
      font: ${font.boldRegular_20};
    }
    &::after {
      content: "/mo";
      position: absolute;
      bottom: 7px;
      right: 0px;
      font: ${font.normalMicroLarge_16};
    }
  }
`;

export const ChangeWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 5px;
  padding: 15px 0px 15px 0px;
`;

export const Container = styled.div`
  .spinner-wrapper {
    height: 50px;
    width: 75px;
    margin: auto;
  }
`;

export const ProratedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 0px 20px 0px;
  border-bottom: 1px solid rgb(220, 224, 227);
`;
